export class Fechas {
  public static getHabiles(): any {
    return [
      {
        fecha: '2018/12/25'
      },
      {
        fecha: '2019/01/01'
      },
      {
        fecha: '2019/04/19'
      },
      {
        fecha: '2019/05/01'
      },
      {
        fecha: '2019/05/21'
      },
      {
        fecha: '2019/07/16'
      },
      {
        fecha: '2019/08/15'
      },
      {
        fecha: '2019/09/17'
      },
      {
        fecha: '2019/09/18'
      },
      {
        fecha: '2019/09/19'
      },
      {
        fecha: '2019/10/31'
      },
      {
        fecha: '2019/11/01'
      },
      {
        fecha: '2019/12/25'
      },
      {
        fecha: '2020/01/01'
      },
      {
        fecha: '2020/04/10'
      },
      {
        fecha: '2020/05/01'
      },
      {
        fecha: '2020/05/21'
      },
      {
        fecha: '2020/06/29'
      },
      {
        fecha: '2020/07/16'
      },
      {
        fecha: '2020/09/17'
      },
      {
        fecha: '2020/09/18'
      },
      {
        fecha: '2020/10/12'
      },
      {
        fecha: '2020/12/08'
      },
      {
        fecha: '2020/12/25'
      },
      {
        fecha: '2021/01/01'
      },
      {
        fecha: '2021/04/02'
      },
      {
        fecha: '2021/05/21'
      },
      {
        fecha: '2021/06/29'
      },
      {
        fecha: '2021/07/16'
      },
      {
        fecha: '2021/09/17'
      },
      {
        fecha: '2021/10/12'
      },
      {
        fecha: '2021/11/01'
      },
      {
        fecha: '2021/12/08'
      },
      {
        fecha: '2022/04/15'
      },
      {
        fecha: '2022/06/29'
      },
      {
        fecha: '2022/08/15'
      },
      {
        fecha: '2022/09/19'
      },
      {
        fecha: '2022/10/12'
      },
      {
        fecha: '2022/10/31'
      },
      {
        fecha: '2022/11/01'
      },
      {
        fecha: '2022/12/08'
      },
      {
        fecha: '2023/04/07'
      },
      {
        fecha: '2023/05/01'
      },
      {
        fecha: '2023/06/29'
      },
      {
        fecha: '2023/08/15'
      },
      {
        fecha: '2023/09/18'
      },
      {
        fecha: '2023/09/19'
      },
      {
        fecha: '2023/10/12'
      },
      {
        fecha: '2023/10/31'
      },
      {
        fecha: '2023/11/01'
      },
      {
        fecha: '2023/12/08'
      },
      {
        fecha: '2023/12/25'
      },
      {
        fecha: '2024/01/01'
      },
      {
        fecha: '2024/03/29'
      },
      {
        fecha: '2024/05/01'
      },
      {
        fecha: '2024/05/21'
      },
      {
        fecha: '2024/07/16'
      },
      {
        fecha: '2024/08/15'
      },
      {
        fecha: '2024/09/17'
      },
      {
        fecha: '2024/09/18'
      },
      {
        fecha: '2024/09/19'
      },
      {
        fecha: '2024/10/31'
      },
      {
        fecha: '2024/11/01'
      },
      {
        fecha: '2024/12/25'
      },
      {
        fecha: '2025/01/01'
      },
      {
        fecha: '2025/04/18'
      },
      {
        fecha: '2025/05/01'
      },
      {
        fecha: '2025/05/21'
      },
      {
        fecha: '2025/07/16'
      },
      {
        fecha: '2025/08/15'
      },
      {
        fecha: '2025/09/17'
      },
      {
        fecha: '2025/09/18'
      },
      {
        fecha: '2025/09/19'
      },
      {
        fecha: '2025/10/31'
      },
      {
        fecha: '2025/12/08'
      },
      {
        fecha: '2025/12/25'
      },
      {
        fecha: '2026/01/01'
      },
      {
        fecha: '2026/04/03'
      },
      {
        fecha: '2026/05/01'
      },
      {
        fecha: '2026/05/21'
      },
      {
        fecha: '2026/06/29'
      },
      {
        fecha: '2026/07/16'
      },
      {
        fecha: '2026/09/17'
      },
      {
        fecha: '2026/09/18'
      },
      {
        fecha: '2026/10/12'
      },
      {
        fecha: '2026/12/08'
      },
      {
        fecha: '2026/12/25'
      },
      {
        fecha: '2027/01/01'
      },
      {
        fecha: '2027/03/26'
      },
      {
        fecha: '2027/05/21'
      },
      {
        fecha: '2027/06/29'
      },
      {
        fecha: '2027/07/16'
      },
      {
        fecha: '2027/09/17'
      },
      {
        fecha: '2028/10/12'
      },
      {
        fecha: '2028/10/31'
      },
      {
        fecha: '2027/10/12'
      },
      {
        fecha: '2027/11/01'
      },
      {
        fecha: '2027/12/08'
      },
      {
        fecha: '2028/04/14'
      },
      {
        fecha: '2028/05/01'
      },
      {
        fecha: '2028/06/29'
      },
      {
        fecha: '2028/08/15'
      },
      {
        fecha: '2028/09/18'
      },
      {
        fecha: '2028/09/19'
      },
      {
        fecha: '2029/08/15'
      },
      {
        fecha: '2029/09/17'
      },
      {
        fecha: '2028/11/01'
      },
      {
        fecha: '2028/12/08'
      },
      {
        fecha: '2028/12/25'
      },
      {
        fecha: '2029/01/01'
      },
      {
        fecha: '2029/03/30'
      },
      {
        fecha: '2029/05/01'
      },
      {
        fecha: '2029/05/21'
      },
      {
        fecha: '2029/06/29'
      },
      {
        fecha: '2029/07/16'
      },
      {
        fecha: '2029/09/18'
      },
      {
        fecha: '2029/09/19'
      },
      {
        fecha: '2029/10/12'
      },
      {
        fecha: '2029/10/31'
      },
      {
        fecha: '2029/11/01'
      },
      {
        fecha: '2029/12/25'
      }
    ];
  }
}
